<template>
  <div>
    <div v-if="isReturnMoney" class="dashboard-container">
      <div>
        <div class="nav">
          <div class="nav_hader">
            <ul class="nav_left">
              <li class="bottom hove" @click="my(num)" :class="mys == true ? 'active' : ''">
                我的回款
              </li>
              <li class="bottom hove" @click="all(num)" :class="customers == true ? 'active' : ''">
                全部回款
              </li>
              <li class="bottom hove" @click="under(num)" :class="unders == true ? 'active' : ''">
                我下属的回款
              </li>
            </ul>
            <ul class="nav_right">
              <li>
                <exportExcel></exportExcel>
              </li>
              <li>
                <el-button style="margin-right:0px" type="primary" class="btn-big" icon="el-icon-plus" @click="onAdd">
                  新增回款
                </el-button>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div style="width: 100%">
            <div class="nav_body">
              <div class="grid">
                <div class="cell">
                  <div class="grid-content bg-purple">更新时间：</div>
                  <div class="">
                    <el-date-picker v-model="value2" type="datetimerange" :picker-options="pickerOptions"
                      @change="onRecordTime()" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right"></el-date-picker>
                  </div>
                </div>
                <div class="cell">
                  <div class="grid-content bg-purple">创建时间：</div>
                  <div class="">
                    <el-date-picker v-model="value3" type="datetimerange" @change="onCreateTime()"
                      :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right"></el-date-picker>
                  </div>
                </div>
                <div class="cell">
                  <div class="grid-content bg-purple">自定义字段：</div>
                  <div>
                    <el-input v-model="selfC" placeholder="请输入自定义字段搜索" clearable @change="chaxun"> </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body">
          <div v-show="false"></div>
          <div class="table">
            <el-table id="educe-table" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
              stripe v-loading="tableLoading" @row-click="handleRead"
              @selection-change="handleSelectionChange">

              <div v-for="(item, index) in fields" :key="index">

                <el-table-column v-if="item.prop == 'photo'" :prop="item.field" :label="item.title">
                  <template slot-scope="scope">
                    <div v-for="i in scope.row.photo" :key="i">
                      <img class="pic" :src="i">
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item.field == 'check_status_name'" sortable :prop="item.field" :label="item.title">
                  <template slot-scope="scope">
                <span v-if="scope.row.check_status === 0 "
                style="color: #409EFF"
                  >待审核</span
                >
                <span
                  v-else-if="scope.row.check_status === 1"
                  style="color: #F56C6C"
                  >审核中</span
                >
                <span
                  v-else-if="scope.row.check_status === 2"
                  style="color: #67C23A"
                  >审核通过</span
                >
                <span
                  v-else-if="scope.row.check_status === 3"
                  style="color: #F56C6C"
                  >审核未通过</span
                >
              </template>
                </el-table-column>
                <el-table-column v-else show-overflow-tooltip :prop="item.field" :label="item.title">
                </el-table-column>
              </div>
              <el-table-column class-name="operation" align="center" fixed="right"  width="145">
                <template slot="header">
                  <span>操作</span>
                  <i class="more iconfont icongengduo" @click="onMore"></i>
                </template>
                <template slot-scope="scope">
                  <el-button @click="handleRead(scope.row)" type="text">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="getData" />
        </div>
        <el-tooltip placement="top" content="返回顶部">
          <back-to-top :visibility-height="300" :back-position="0" transition-name="fade" />
        </el-tooltip>
      </div>
      <add ref="add"></add>
      <set-table ref="setting" types="receivables" :selfState='selfState'></set-table>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import add from "./add";
import setTable from "@/components/setTable";
import { receivablesList, delReceivables } from "@/api/returnMoney.js";
// import { getSelfAPI } from "@/api/common";
import { getFieldControl } from '@/api/user'
import Pagination from "@/components/Pagination";
import exportExcel from "@/components/exportExcel"
export default {
  name: "returnMoney",
  inject: ["reload"],
  components: {
    Pagination,
    add,
    setTable,
    exportExcel
  },
  data() {
    return {
      //当前页面state
      selfState: 'receivables',
      num: 1,
      collpase: false,
      customers: false,
      mys: true,
      unders: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 1 - 60 * 60 * 24
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      recordTime: "",
      tableData: [],
      vme: "",
      input: "",
      createtime: "",
      if_leader:'',
      start_createtime: "",
      end_createtime: "",
      start_updatetime: "",
      end_updatetime: "",
      multipleSelection: [],
      fileList: [],
      baseURL: this.axios.defaults.baseURL,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      fields: [],
      value3: "",
      value2: "",
      selfC: "",
      tableLoading: true
    };
  },
  computed: {
    isReturnMoney() {
      return this.$route.name === "returnmoney";
    },
  },
  filters: {
    formatDate(value) {
      const date = new Date(value * 1000);
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1).toString().padStart(2, 0);
      let D = date.getDate().toString().padStart(2, 0);
      return `${Y}-${M}-${D}`;
    },
  },
  created() {
    this.getFields();
  },
  mounted() {
    this.if_leader=window.sessionStorage.getItem('hk_if_leader');
    if(this.if_leader == 3){

      this.all()
    }else if(this.if_leader == 1){
      this.under()
    }else{
      this.my()
    }
   // this.all();

  },
  methods: {
    // async getFields() {
    //   const res = await getSelfAPI({
    //     account_id: this.$store.state.user.token.account_id,
    //     user_id: this.$store.state.user.token.userid,
    //     state: this.selfState,
    //   });
    //   if (res.code == 1) {
    //     this.fields = res.data.merge_field
    //     console.log(this.fields)
    //   } else {
    //     this.fields = []
    //   }
    // },
    async getFields() {
      let fields = await getFieldControl({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        types: 'receivables'
      })
      this.tableLoading = false
      this.fields = fields.data
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 名称查询
    chaxun() {
      this.listQuery.page = 1
      this.getData();
    },
    // 创建时间
    onCreateTime() {
      if (Array.isArray(this.value3)) {
        let a = this.value3[0].valueOf();
        let b = this.value3[1].valueOf();
        this.start_createtime = parseInt(a / 1000);
        this.end_createtime = parseInt(b / 1000);

      } else {
        this.start_createtime = "";
        this.end_createtime = "";

      }
      this.listQuery.page = 1
      this.getData();
    },
    // 更新时间
    onRecordTime() {
      if (Array.isArray(this.value2)) {
        let a = this.value2[0].valueOf();
        let b = this.value2[1].valueOf();
        this.start_updatetime = parseInt(a / 1000);
        this.end_updatetime = parseInt(b / 1000);

      } else {
        this.start_updatetime = "";
        this.end_updatetime = "";

      }
      this.listQuery.page = 1
      this.getData();
    },
    // onCreateTime() {
    //   let a = this.createtime[0].valueOf();
    //   let b = this.createtime[1].valueOf();

    //   this.start_createtime = a / 1000;
    //   this.end_createtime = b / 1000;
    //   this.getData();
    // },
    // // 实际跟进时间
    // onRecordTime() {
    //   let a = this.recordTime[0].valueOf();
    //   let b = this.recordTime[1].valueOf();
    //   this.start_followtime = a / 1000;
    //   this.end_followtime = b / 1000;
    //   this.getData();
    // },

    async getData(d) {

      const tableData = await receivablesList({
        number_page: d?.limit ?? 20,
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        if_leader: this.if_leader,
        start_createtime: this.start_createtime,
        end_createtime: this.end_createtime,
        start_updatetime: this.start_updatetime,
        end_updatetime: this.end_updatetime,
        name: this.input,
        page: this.listQuery.page,
        customer_id: this.$route.query.id,
        self_content: this.selfC
      });
      this.total = tableData.count;
      this.tableData = tableData.data;
      for (var a = 0; a < tableData.data.length; a++) {
      this.tableData[a].return_time=(new Date(tableData.data[a].return_time * 1000)).toLocaleDateString().replace(/\//g,'-')+' '+(new Date(tableData.data[a].return_time *1000)).toTimeString().substring(0,8)
      }
    },
    async getData1(d) {

      const tableData = await receivablesList({
        number_page: d?.limit ?? 20,
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        if_leader: this.if_leader,
        start_createtime: this.start_createtime,
        end_createtime: this.end_createtime,
        start_followtime: this.start_followtime,
        end_followtime: this.end_followtime,
        name: this.input,
        page: this.listQuery.page,
      });
      this.total = tableData.count;
      this.tableData = tableData.data;
      for (var a = 0; a < tableData.data.length; a++) {
      this.tableData[a].return_time=(new Date(tableData.data[a].return_time * 1000)).toLocaleDateString().replace(/\//g,'-')+' '+(new Date(tableData.data[a].return_time *1000)).toTimeString().substring(0,8)
      }
    },
    pull() {
      this.toggle = !this.toggle;
    },
    all(num) {
      this.customers = true;
      this.mys = false;
      this.unders = false;
      this.if_leader = 3;
      this.listQuery.limit = 20
      this.listQuery.page = 1
      if (num == 1) {
        this.getData1();
      } else {
        this.getData();
      }
    },
    my(num) {
      this.customers = false;
      this.mys = true;
      this.unders = false;
      this.if_leader = 0;
      this.listQuery.limit = 20
      this.listQuery.page = 1
      if (num == 1) {
        this.getData1();
      } else {
        this.getData();
      }
    },
    under(num) {
      this.customers = false;
      this.mys = false;
      this.unders = true;
      this.if_leader = 1;
      this.listQuery.limit = 20
      this.listQuery.page = 1
      if (num == 1) {
        this.getData1();
      } else {
        this.getData();
      }
    },
    handleRead(row) {
      // this.$store.commit("app/SET_RETURNMONEY", row);
      this.$router.push({
        name: "returnmoneyDetail",
        query: {
          owner: row.owner,
          if_leader:this.if_leader,
        },
        params: {
          id: row.id,
        },
      });
    },
    onAdd() {
      this.$refs.add.open();
    },
    del() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: "请选择删除项!",
        });
        return;
      }
      this.$confirm("此您确定要删除当前选中回款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = [];
          for (const i of this.multipleSelection) {
            ids.push(i.id);
          }
          let res = await delReceivables({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            ids: ids.join(","),
          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.reload();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    onMore() {
      this.$refs.setting.open();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/index-common.scss";
</style>
